import { Avatar, Badge, Box, Button, Card, Group, Text, Title } from "@mantine/core";
import dayjs from "dayjs";
import { getAllJobs, getAllOtherJobs, getExpiredJobs, getJobBySlug } from "../../utils/serverSupabase";
import JobSchema from "../../components/JobSchema";
import Seo from "../../components/SEO";
import {
  IconArrowAutofitLeft,
  IconArrowBack,
  IconArrowBarLeft,
  IconArrowBearLeft,
  IconArrowBigLeft,
  IconArrowBigLeftLine,
  IconArrowLeft,
} from "@tabler/icons";
import Link from "next/link";

const formatter = (value) => (!Number.isNaN(parseFloat(value)) ? `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null);
function isEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}
export default function JobPage({ job }) {
  const handleClick = () => {};
  let jobUrl;
  if (isEmail(job.application_url)) {
    jobUrl = "mailto:" + job.application_url + `?subject=${job.title} - ReactNativeJobs.com`;
  } else {
    try {
      jobUrl = new URL(job.application_url);
      jobUrl.searchParams.append("ref", "reactnativejobs.com");
    } catch (err) {
      jobUrl = job.application_url;
    }
  }
  return (
    <Box>
      <Seo title={`${job.title} - ${job.company}`} description={job.description} />
      <JobSchema job={job} />
      <Link href={"/"} passHref>
        <Button component="a" p={0} mb={"xl"} variant="subtle" leftIcon={<IconArrowLeft />}>
          {"Back to jobs"}
        </Button>
      </Link>
      <Title order={1}>{job.title}</Title>

      <Group>
        <Avatar size="lg" radius={100} src={job.logo_url} name={job.company}>
          {job.company?.[0]}
        </Avatar>
        <Text weight={500}>{job.company}</Text>
      </Group>
      <Button component="a" mt="md" size="lg" role="link" target="blank" href={jobUrl} onClick={handleClick}>
        Apply Now
      </Button>
      <Text pt="md">{job.job_type}</Text>
      <Text pb="sm" weight={"bold"}>
        {job.location}
      </Text>
      <Group>
        <Text>
          {formatter(job.min_salary)}
          {job.max_salary ? " - " + formatter(job.max_salary) : ""}
        </Text>
      </Group>
      <Box>
        <div dangerouslySetInnerHTML={{ __html: job.description }}></div>
      </Box>
    </Box>
  );
}

export async function getStaticProps(props) {
  const {
    params: { slug },
  } = props;
  const job = await getJobBySlug(slug);
  return {
    props: {
      job,
    },
  };
}

export async function getStaticPaths() {
  const jobs = await getAllJobs();
  const otherJobs = await getAllOtherJobs();
  const expiredJobs = await getExpiredJobs();
  return {
    paths: [...jobs, ...otherJobs, ...expiredJobs].map((p) => ({
      params: {
        slug: String(p.slug),
      },
    })),
    fallback: false,
  };
}
